import styled from 'styled-components'

export const StyledLineTournamentSport = styled.span`
  align-items: center;
  display: flex;
  gap: 4px;
  grid-area: text;
  padding-right: 4px;
`
